module.exports = __webpack_public_path__ + "img/gtb-logo.5b405c6b.svg";